import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import SocialLinks from '../components/SocialLinks';
//import Subscribe from '../components/Subscribe';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';

import Github from '../components/Github';

import dark from '../assets/images/data8.png';
//import demoImage1 from '../assets/images/demo-image-01.jpg';
import demoImage2 from '../assets/images/tech1.jpg';
import Tech from '../assets/images/tech.jpg';
//import downloadFile from '../assets/downloads/PatriciaCollado_DataAnalyst_2020CV.pdf';
const IndexPage = () => (
  <Layout>
    <Header />

    <header className="masthead">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center">
          <h1 className="mx-auto my-0 text-uppercase">{config.heading}</h1>
          <h2 className="text-white-50 mx-auto mt-2 mb-5">
            {config.subHeading}
          </h2>
          <Scroll type="id" element="about">
            <a href="#about" className="btn btn-primary">
              About Me
            </a>
          </Scroll>
        </div>
      </div>
    </header>

    <section id="about" className="about-section text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4">Patricia Collado</h2>
            <p className="text-white-50">
              My name is Patricia Collado, I am a data analyst and data
              engineer. My experience is mainly in data management, mining,
              visualization, geospatial analysis, and machine learning, as well
              as in security and intelligence data bases. During my last
              projects, I have exploited a combination of data analysis and
              technology advances in several fields. That is why I am looking to
              develop better digital products based on this approach.I would
              like to have the chance to contribute with my knowledge in
              technology startups as data analyst or engineer in order to
              improve the services offered by their digital platforms, and help
              expanding their application software to benefit more people. I
              really look forward to work in a place where creativity is open to
              improve users needs.
            </p>
          </div>
        </div>
        <img src={dark} className="img-fluid rounded" alt="myself" />
      </div>
    </section>

    <section id="projects" className="projects-section bg-light">
      <div className="container">
        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-8 col-lg-7">
            <img className="img-fluid mb-3 mb-lg-0 rounded" src={Tech} alt="" />
          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="featured-text text-center text-lg-left">
              <h4>Services</h4>
              <div className="text-black-50 mb-0">
                <ul className="text-black-50 mb-0">
                  <li> Augmented reality </li>
                  <li> Business intelligence </li>
                  <li> Data visualization </li>
                  <li> Data mining </li>
                  <li> Geospatial analysis </li>
                  <li> Machine learning </li>
                  <li> Web scrapping </li>
                  <li> Mobile app development </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center no-gutters">
            <div className="col-lg-6">
              <img className="img-fluid " src={demoImage2} alt="" />
            </div>
            <div className="col-lg-6 order-lg-first">
              <div className="bg-black text-center h-100 project">
                <div className="d-flex h-100">
                  <div className="project-text w-100 my-auto text-center text-lg-left">
                    <h4 className="text-white">Skills</h4>
                    <div className="text-white-50 mb-0">
                      <ul className="text-white-50 mb-0">
                        <li> Python and Flask </li>
                        <li> AWS and Google Cloud Platform </li>
                        <li> Tableau </li>
                        <li> MySQL, Postgres, and MongoDB </li>
                        <li> React and NodeJs </li>
                        <li> Microsoft Office </li>
                        <li> Flutter and Dart </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Github />
    <ContactForm />
    <SocialLinks />
    <Footer />
  </Layout>
);

export default IndexPage;
